// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iHCT","name":"styles_name__lAGTW","phone":"styles_phone__2X9Tr"};